(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
/**
 * カート数量の切り詰め通知(監査 3-3)。
 *
 * 素の HTML(max 属性 + 行内の在庫実数)で防ぎ、Liquid 側で在庫割れを警告した上で、
 * ここは「サーバが実際に数量を丸めた場合」だけを担当する上乗せ層。
 *   1. 更新ボタンの click を奪い、要求した数量を /cart/update.js に投げる
 *   2. 戻ってきたカートの数量と要求値を突合し、差分を sessionStorage に置く
 *   3. reload する(小計・ポイント・配送判定はすべて Liquid が正しく再計算する)
 *   4. 読み込み時に sessionStorage を読んで通知領域へ描く
 * 失敗時は必ずネイティブ送信へ落とす(通知が出ないだけで、更新自体は成功する)。
 */
(function () {
  var STORE_KEY = 'toreca:cart-adjusted';
  var form = document.querySelector('[data-cart-form]');
  var live = document.querySelector('[data-cart-live]');

  function render(rows) {
    if (!live || !rows || !rows.length) return;

    var box = document.createElement('div');
    box.className = 'cart-notice cart-notice--warn';

    var head = document.createElement('b');
    head.textContent = live.getAttribute('data-cart-adjusted-title') || '';
    box.appendChild(head);

    var body = document.createElement('div');
    body.className = 'cart-notice__body';

    var lead = document.createElement('p');
    lead.textContent = live.getAttribute('data-cart-adjusted-lead') || '';
    body.appendChild(lead);

    var list = document.createElement('ul');
    rows.forEach(function (row) {
      var line = document.createElement('li');
      line.textContent = (live.getAttribute('data-cart-adjusted-line-open') || '') + row.title +
        (live.getAttribute('data-cart-adjusted-line-middle') || '') + row.want +
        (live.getAttribute('data-cart-adjusted-line-after-wanted') || '') + row.got +
        (live.getAttribute('data-cart-adjusted-line-after-actual') || '');
      list.appendChild(line);
    });
    body.appendChild(list);

    box.appendChild(body);
    live.appendChild(box);
  }

  function flush() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(STORE_KEY);
      if (raw) sessionStorage.removeItem(STORE_KEY);
    } catch (error) {
      return;
    }
    if (!raw) return;
    try {
      render(JSON.parse(raw));
    } catch (error) {
      /* 壊れた値は捨てる */
    }
  }

  flush();

  if (!form) return;

  var button = form.querySelector('[data-cart-update]');
  if (!button || typeof window.fetch !== 'function') return;

  var root = '/';
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    root = window.Shopify.routes.root;
  }

  button.addEventListener('click', function (event) {
    if (button.getAttribute('data-fallback') === '1') return;

    /**
     * max を超えた数量が入っている場合は preventDefault せずに素の送信へ渡す。
     * ブラウザの制約検証が送信を止め、日本語のバリデーションメッセージを出すので、
     * サーバに丸めさせる前に入力段階で防げる(= JS 無効時と同じ挙動になる)。
     */
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    var inputs = form.querySelectorAll('[data-cart-qty]');
    if (!inputs.length) return;

    var updates = {};
    var wanted = {};
    var index;

    for (index = 0; index < inputs.length; index += 1) {
      var key = inputs[index].getAttribute('data-key');
      var quantity = parseInt(inputs[index].value, 10);
      if (!key || isNaN(quantity) || quantity < 0) return;
      updates[key] = quantity;
      wanted[key] = {
        quantity: quantity,
        title: inputs[index].getAttribute('data-title') || ''
      };
    }

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');

    window
      .fetch(root.replace(/\/$/, '') + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        return response.json();
      })
      .then(function (cart) {
        var lines = cart.items || [];
        var rows = [];
        var seen = {};

        lines.forEach(function (line) {
          seen[line.key] = true;
          var want = wanted[line.key];
          if (want && want.quantity !== line.quantity) {
            rows.push({
              title: line.product_title || want.title,
              want: want.quantity,
              got: line.quantity
            });
          }
        });

        Object.keys(wanted).forEach(function (key) {
          if (wanted[key].quantity > 0 && !seen[key]) {
            rows.push({ title: wanted[key].title, want: wanted[key].quantity, got: 0 });
          }
        });

        try {
          sessionStorage.setItem(STORE_KEY, JSON.stringify(rows));
        } catch (error) {
          /* 保存できなくても更新自体は成立させる */
        }
        window.location.reload();
      })
      .catch(function () {
        button.setAttribute('data-fallback', '1');
        button.removeAttribute('aria-busy');
        button.click();
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-contact-form]');
    if (!form) return;

    const minimumFillTimeMs = 3000;
    const loadedAt = Date.now();
    const submit = form.querySelector('[data-contact-submit]');
    const honeypot = form.querySelector('[data-contact-honeypot]');
    const error = form.querySelector('[data-contact-form-error]');
    const initialLabel = submit ? submit.textContent : '';

    const showError = (message) => {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
      error.focus();
    };

    const clearError = () => {
      if (!error) return;
      error.textContent = '';
      error.hidden = true;
    };

    form.addEventListener('input', clearError);

    form.addEventListener('submit', (event) => {
      if (form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }

      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        showError('送信できませんでした。入力内容をご確認ください。');
        return;
      }

      if (Date.now() - loadedAt < minimumFillTimeMs) {
        event.preventDefault();
        showError('ページを開いてから数秒待って、もう一度送信してください。');
        return;
      }

      form.dataset.submitting = 'true';
      if (submit) {
        submit.disabled = true;
        submit.textContent = submit.dataset.contactSubmittingLabel || '送信中…';
      }
    });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      delete form.dataset.submitting;
      if (submit) {
        submit.disabled = false;
        submit.textContent = initialLabel;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * メガメニューの任意補助。リンク本体は Liquid + details/summary で描画済みなので、
   * JS 無効でもモバイル・PC ともすべてのジャンルへ到達できる。
   */
  (() => {
    const desktop = () => window.matchMedia('(min-width: 1100px)').matches;
    const headers = () => [...document.querySelectorAll('.site-header')];
    const menus = () => [...document.querySelectorAll('.site-header details[data-mega]')];

    const measureHeaders = () => {
      const header = headers()[0];
      if (header) document.documentElement.style.setProperty('--site-header-height', `${header.offsetHeight}px`);
    };

    /* CSS の content-visibility 上書きに加える保険。小さい群を閉じたまま
       1100px 以上へリサイズしても、UA style によるジャンル欠落を起こさない。 */
    const syncGroups = () => {
      if (!desktop()) return;
      document.querySelectorAll('.site-header details.mm-group').forEach((group) => { group.open = true; });
    };

    const syncDrawerLock = () => {
      const drawerOpen = menus().some((menu) => menu.open && menu.hasAttribute('data-drawer'));
      document.documentElement.classList.toggle('mega-drawer-open', drawerOpen && !desktop());
      document.body.classList.toggle('mega-drawer-open', drawerOpen && !desktop());
    };

    const bindMenu = (menu) => {
      if (menu.dataset.megaBound === 'true') return;
      menu.dataset.megaBound = 'true';

      menu.addEventListener('toggle', () => {
        if (menu.open) menus().forEach((other) => { if (other !== menu) other.open = false; });
        syncDrawerLock();
        measureHeaders();
      });

      let hoverTimer;
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !desktop()) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(() => {
          menus().forEach((other) => { if (other !== menu) other.open = false; });
          menu.open = true;
        }, 120);
      });
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || !desktop()) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(() => { menu.open = false; }, 200);
      });
      menu.addEventListener('focusout', () => {
        if (!desktop()) return;
        requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        });
      });
    };

    menus().forEach(bindMenu);
    syncGroups();
    measureHeaders();
    syncDrawerLock();

    if (document.documentElement.dataset.megaMenuEventsBound === 'true') return;
    document.documentElement.dataset.megaMenuEventsBound = 'true';

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = menus().find((menu) => menu.open);
      if (!openMenu) return;
      openMenu.open = false;
      openMenu.querySelector('summary')?.focus();
    });

    document.addEventListener('pointerdown', (event) => {
      menus().forEach((menu) => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });

    window.addEventListener('resize', () => {
      syncGroups();
      syncDrawerLock();
      measureHeaders();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaitori-metaobject"]) return;
  try {
    
  function initPackPagination() {
    document.querySelectorAll('.kaitori-page--genre .kaitori-index').forEach((list, index) => {
      if (list.dataset.paginated) return;
      const items = Array.from(list.children);
      if (items.length <= 20) return;
      list.dataset.paginated = 'true';
      list.id ||= `KaitoriPackList-${index}`;
      let visible = 20;
      const mobile = window.matchMedia('(max-width: 599px)');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn btn--out kaitori-index__more';
      button.textContent = 'もっと見る';
      button.setAttribute('aria-controls', list.id);
      list.after(button);
      const update = () => {
        items.forEach((item, i) => { item.hidden = mobile.matches && i >= visible; });
        button.hidden = !mobile.matches || visible >= items.length;
      };
      button.addEventListener('click', () => {
        const next = items[visible]?.querySelector('a');
        visible += 20;
        update();
        next?.focus({ preventScroll: true });
      });
      mobile.addEventListener('change', update);
      update();
    });
  }
  initPackPagination();
  document.addEventListener('shopify:section:load', initPackPagination);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-page"]) return;
  try {
    
  (() => {
    const content = document.querySelector('[data-legal-content]');
    if (!content) return;

    /**
     * 幅の広い表(特商法の配送料一覧など)を横スクロールできる箱に包む。
     * .rte__scroll は assets/components.css(Lane 0B)が持つユーティリティ。
     * これが動かない環境でも .legal-page__content 側の overflow-x で body は守られる。
     */
    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('rte__scroll')) return;
      const box = document.createElement('div');
      box.className = 'rte__scroll';
      box.setAttribute('tabindex', '0');
      box.setAttribute('role', 'group');
      const caption = table.querySelector('caption');
      box.setAttribute('aria-label', caption ? caption.textContent.trim() : '表');
      table.parentNode.insertBefore(box, table);
      box.appendChild(table);
    });

    /** 見出しが3本以上あるページだけ目次を出す。 */
    const toc = document.querySelector('[data-legal-toc]');
    const list = document.querySelector('[data-legal-toc-list]');
    if (!toc || !list) return;

    const headings = content.querySelectorAll('h2');
    if (headings.length < 3) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `legal-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * 商品詳細の JS。★ 価格を「計算」しない。
   * 選択中の価格表示は、選ばれたラジオと同じ DOM 行に描かれている価格テキストを
   * そのままコピーするだけ。したがって JS が価格を取り違える経路が存在しない。
   * JS が全く動かなくても、素の <input name="id"> が正しい variant を送信する。
   */
  (() => {
    const initSection = (root) => {
      if (root.dataset.pdpReady === 'true') return;
      root.dataset.pdpReady = 'true';

      const form = root.querySelector('[data-pdp-form]');
      const qtyInput = root.querySelector('[data-pdp-qty]');
      const qtyDec = root.querySelector('[data-pdp-qty-dec]');
      const qtyInc = root.querySelector('[data-pdp-qty-inc]');
      const qtyNote = root.querySelector('[data-pdp-qty-note]');
      const chosen = root.querySelector('[data-pdp-chosen]');
      const chosenCond = root.querySelector('[data-pdp-chosen-cond]');
      const chosenPrice = root.querySelector('[data-pdp-chosen-price]');
      const stickyCond = root.querySelector('[data-pdp-sticky-cond]');
      const stickyPrice = root.querySelector('[data-pdp-sticky-price]');
      const errorBox = root.querySelector('[data-pdp-error]');

      const clearError = () => {
        if (!errorBox) return;
        errorBox.textContent = '';
        errorBox.hidden = true;
      };

      const showError = (message) => {
        if (!errorBox) return;
        errorBox.textContent = message;
        errorBox.hidden = false;
      };

      const syncQuantityControls = () => {
        if (!qtyInput) return;
        const value = Number(qtyInput.value);
        const min = Number(qtyInput.min) || 1;
        const max = qtyInput.hasAttribute('max') ? Number(qtyInput.max) : 0;

        if (qtyDec) qtyDec.disabled = !Number.isFinite(value) || value <= min;
        if (qtyInc) qtyInc.disabled = Number.isFinite(max) && max > 0 && value >= max;
      };

      const applyQuantityLimit = (radio) => {
        if (!qtyInput) return;
        const limit = radio && radio.dataset.qtyMax ? Number(radio.dataset.qtyMax) : 0;

        if (Number.isFinite(limit) && limit > 0) {
          qtyInput.max = String(limit);
          if (Number(qtyInput.value) > limit) qtyInput.value = String(limit);
          if (qtyNote) {
            const slot = qtyNote.querySelector('b');
            if (slot) slot.textContent = String(limit);
            qtyNote.hidden = false;
          }
        } else {
          qtyInput.removeAttribute('max');
          if (qtyNote) qtyNote.hidden = true;
        }
        qtyInput.setCustomValidity('');
        syncQuantityControls();
      };

      const syncSelection = () => {
        const radio = root.querySelector('.cond-choice__radio:checked');
        if (!radio) return;

        const row = radio.closest('.cond-choice__row');
        const priceNode = row ? row.querySelector('.cond-choice__price') : null;
        const priceText = priceNode ? priceNode.textContent.trim() : '';
        const condText = radio.dataset.condLabel || '';

        if (chosen && priceText) {
          if (chosenCond) chosenCond.textContent = condText;
          if (chosenPrice) chosenPrice.textContent = priceText;
          chosen.hidden = false;
        }
        if (stickyCond && condText) stickyCond.textContent = condText;
        if (stickyPrice && priceText) stickyPrice.textContent = priceText;

        applyQuantityLimit(radio);
        clearError();

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (error) {
          /* URL の書き換えに失敗しても購入導線には影響させない */
        }
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('.cond-choice__radio')) syncSelection();
      });

      if (qtyInput) {
        qtyInput.addEventListener('input', () => {
          const limit = Number(qtyInput.max);
          if (Number.isFinite(limit) && limit > 0 && Number(qtyInput.value) > limit) {
            qtyInput.setCustomValidity('ご購入いただける数量の上限を超えています。');
          } else {
            qtyInput.setCustomValidity('');
          }
          syncQuantityControls();
        });
      }

      const stepQuantity = (direction) => {
        if (!qtyInput) return;
        if (direction > 0) {
          qtyInput.stepUp();
        } else {
          qtyInput.stepDown();
        }
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      if (qtyDec) qtyDec.addEventListener('click', () => stepQuantity(-1));
      if (qtyInc) qtyInc.addEventListener('click', () => stepQuantity(1));

      /* 監査 3-2: 数量が在庫を超えたときに Shopify 既定のエラー画面へ落とさず、
         日本語のメッセージをその場に出す。fetch が使えない環境では素の送信に委ねる。 */
      if (form && window.fetch && window.FormData) {
        form.addEventListener('submit', (event) => {
          if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
            event.preventDefault();
            return;
          }

          const submitter = event.submitter;
          if (submitter && submitter.disabled) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          clearError();

          const controls = form.querySelectorAll('button[type="submit"]');
          controls.forEach((button) => { button.disabled = true; });

          window
            .fetch('/cart/add.js', {
              method: 'POST',
              body: new FormData(form),
              headers: { Accept: 'application/json' }
            })
            .then((response) => {
              if (response.ok) {
                window.location.href = root.dataset.cartUrl || '/cart';
                return null;
              }
              return response.json().catch(() => null);
            })
            .then((payload) => {
              if (payload === null) return;
              controls.forEach((button) => { button.disabled = false; });

              showError('ご指定の数量はご用意できませんでした。数量を減らしてもう一度お試しください。');
            })
            .catch(() => {
              controls.forEach((button) => { button.disabled = false; });
              showError('通信に失敗しました。時間をおいてもう一度お試しください。');
            });
        });
      }

      syncSelection();
    };

    document.querySelectorAll('[data-pdp]').forEach(initSection);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-pdp]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
